// import AOS from "aos";
// import { tns } from "../../node_modules/tiny-slider/src/tiny-slider";
// import Cookies from "../../node_modules/js-cookie/src/js.cookie.js";
//import "bootstrap/dist/js/bootstrap.min.js";

(function () {
    ("use strict");

    //$(document).ready(function(){
    sliderModals();
    //});

    // $(document).on("ready", function () {
    //     runYT();
    // });

    function sliderModals() {
        $(".modal-outer-wrap").each(function () {
            var par = $(this).closest(".slide"),
                box = par.find(".banner-video-modal"),
                close = $(this).find(".close-icon"),
                lTrigger = par.find(".modal-link-trigger"),
                iTrigger = par.find(".modal-img-trigger"),
                mod = box.dialog({
                    modal: true,
                    autoOpen: false,
                    width: 950,
                    classes: {
                        "ui-dialog": "hero-video-modal",
                    },
                });
            // par.on("click", function () {
            //     mod.dialog("open");
            // });
            par.on(
                "click",
                ".modal-link-trigger, .modal-img-trigger, .overlay",
                function () {
                    mod.dialog("open");
                    var isrc = box.find("iframe").attr("src");
                    //box.find("iframe").attr("src", isrc + "&autoplay=1");
                    var iframeID = box.find("iframe").attr("id");
                    box.find(".video-wrap iframe").each(function () {
                        var self = $(this);
                        console.log("video iframe each");
                        var iframe = document.getElementById(iframeID);
                        var isrc = self.attr("src");
                        var newsrc = isrc.replace("autoplay=0", "autoplay=1");
                        self.attr("src", newsrc);
                        iframe.contentWindow.postMessage(
                            '{"event":"command","func":"playVideo","args":""}',
                            "*"
                        );
                    });
                }
            );
            mod.on("dialogclose", function () {
                $(".video-wrap iframe").each(function () {
                    var isrc = box.find("iframe").attr("src");
                    //box.find("iframe").attr("src", isrc + "&autoplay=0");
                    this.contentWindow.postMessage(
                        '{"event":"command","func":"pauseVideo","args":""}',
                        "*"
                    );
                });
            });
            close.on("click", function () {
                mod.dialog("close");
                $(".video-wrap iframe").each(function () {
                    this.contentWindow.postMessage(
                        '{"event":"command","func":"pauseVideo","args":""}',
                        "*"
                    );
                });
            });
        });
    }

    function runYT() {
        // Custom Hero Youtube Background

        const tag = document.createElement("script");
        tag.src = "https://www.youtube.com/iframe_api";
        const firstScriptTag = document.getElementsByTagName("script")[0];
        firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

        $(".ytplayer").each(function () {
            const self = $(this);

            const bgVideoID = self.attr("data-video");
            console.log(bgVideoID);
            const videoIDA = self.attr("id");
            console.log(videoIDA);
            const playerOptions = {
                autoplay: 0,
                //mute: 1,
                autohide: 1,
                modestbranding: 1,
                rel: 0,
                showinfo: 0,
                controls: 0,
                //disablekb: 1,
                enablejsapi: 1,
                iv_load_policy: 3,
                //loop: 1,
                playsinline: 1,
                playlist: bgVideoID,
            };

            let ytPlayer;

            //function onYouTubeIframeAPIReady() {
            console.log("onYouTubeIframeAPIReady");
            ytPlayer = new YT.Player(videoIDA, {
                width: "1280",
                height: "720",
                videoId: bgVideoID,
                playerVars: playerOptions,
                events: {
                    onReady: onPlayerReady,
                    //onStateChange: onPlayerStateChange,
                },
            });
            //}

            function onPlayerReady(event) {
                event.target.playVideo();
                console.log("onPlayerReady");
                // const videoDuration = event.target.getDuration();
                // setInterval(function () {
                //     const videoCurrentTime = event.target.getCurrentTime();
                //     const timeDifference = videoDuration - videoCurrentTime;

                //     if (2 > timeDifference > 0) {
                //         event.target.seekTo(0);
                //     }
                // }, 2500);
            }
            // function onPlayerStateChange(event) {
            //     if (event.data == YT.PlayerState.PLAYING) {
            //         setTimeout(function () {
            //             self.style.opacity = "1";
            //             yt_video_resize();
            //         }, 500);
            //     }
            // }

            // jQuery(window).resize(function () {
            //     yt_video_resize();
            // });

            // function yt_video_resize() {
            //     if (jQuery(window).width() < 1199) {
            //         var height = jQuery(".b40-hero-bg").height();
            //         console.log(height);

            //         jQuery(".header__background iframe").css({
            //             width: height * (16 / 9),
            //         });

            //         var width = jQuery(".header__background iframe").width();

            //         jQuery(".header__background iframe").css({
            //             height: width * (9 / 16),
            //         });
            //     } else {
            //         jQuery(".header__background iframe").css({
            //             width: "120%",
            //             height: "120%",
            //         });
            //     }
            // }
        });
    }
})();
